/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeGoogleSlidesData } from './moe-google-slides.data';
import { IMoeGoogleSlidesProps } from './moe-google-slides.props.autogenerated';

export interface IMoeGoogleSlidesViewProps extends IMoeGoogleSlidesProps<IMoeGoogleSlidesData> {}

/**
 *
 * MoeGoogleSlides component
 * @extends {React.PureComponent<IMoeGoogleSlidesProps<IMoeGoogleSlidesData>>}
 */
class MoeGoogleSlides extends React.PureComponent<IMoeGoogleSlidesProps<IMoeGoogleSlidesData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeGoogleSlides;
